import { h, render } from 'preact'

const FastTrackChevrons = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 25"
      className={className}
      fill="#FBE20A"
    >
      <polygon
        fill-rule="evenodd"
        clip-rule="evenodd"
        points="19.4,12.2 11,3.8 14.8,0 27,12.2 14.8,24.4 11,20.6"
      />
      <path d="M8.4 12.2L0 3.8 3.8 0 16 12.2 3.8 24.4 0 20.6l8.4-8.4zm-7-8.4l8.4 8.4-8.4 8.4L3.8 23l10.8-10.8L3.8 1.4 1.4 3.8z" />
    </svg>
  )
}

export default FastTrackChevrons



// WEBPACK FOOTER //
// ./src/js/components/icons/FastTrackChevrons.js